import { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Header from "./components/header";
import Middle from "./components/middle";
import Footer from "./components/footer";
import CertificatesService from "services/CertificatesService";
import LandingPageConfigsService from "services/LandingPageConfigsService";
import { useAuth } from "context/authContext";
import LoadingComponent from "assets/theme/functions/loadingAnimation";


function Overview() {
    const { state } = useLocation();
    const { tenantId, basePath } = state || {};
    const [loading, setLoading] = useState(true);
    const [certificates, setCertificates] = useState([]);
    const [landingPageConfig, setLandingPageConfig] = useState({});
    const { token } = useAuth();
    const navigate = useNavigate();

    const fetchCertificates = async () => {
        try {
            const [certificateResponse, landingPageResponse] =
                await Promise.all([
                    await CertificatesService.getCertificates(tenantId, token),
                    await LandingPageConfigsService.getLandingPageConfigs(tenantId, token)
                ]);

            setCertificates(certificateResponse?.data?.data);
            setLandingPageConfig(landingPageResponse?.data?.data[0]);
        }
        catch (error) {
            navigate(`${basePath}`, {
                state: {
                    id: 1,
                    error
                }
            });
        }
        finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        try {
            if (!tenantId) {
                navigate('/login');
                return;
            }

            const init = async () => {
                await fetchCertificates();
            };

            init();
        }
        catch (error) {
            console.error("Error initializing landing page:", error);
        }
    }, [tenantId]);

    if (loading) {
        return <LoadingComponent />
    }

    return (
        <>
            <Header config={landingPageConfig} />
            <Middle id={tenantId} certificates={certificates} />
            <Footer config={landingPageConfig} />
        </>
    );
}

export default Overview;
